import React, { useContext } from "react";
import TaxContext from "~/contexts/TaxContext";
import ThemeContext from "~/contexts/ThemeContext";
import Checkbox from "~/components/Checkbox/Checkbox";
import { Product } from "~/entities/productEntities";
import {
  ProductModalModifierHeaderFontSize,
  ProductModalModifierFontSize,
} from "~/theme/models/themeModels";
import styles from "./AlternateProductSelection.module.css";
import clsx from "clsx";

type AlternateProductSelectionProps = {
  prodOptions: Product[];
  selectedProductCode: string;
  onProductSelect: (product: Product) => void;
};

const AlternateProductSelection: React.FC<AlternateProductSelectionProps> = ({
  prodOptions,
  selectedProductCode,
  onProductSelect,
}) => {
  const { formatAmount } = useContext(TaxContext);
  const { template } = useContext(ThemeContext);

  const headerBackgroundColor =
    template.productScreen.modifiers.headerBackgroundColour;
  const headerFontSize =
    ProductModalModifierHeaderFontSize[
      template.productScreen.modifiers.headerFontSize
    ];
  const headerFontColor = template.productScreen.modifiers.headerFontColour;
  const modifierFontSize =
    ProductModalModifierFontSize[template.productScreen.modifiers.fontSize];
  const modifierFontColor = template.productScreen.modifiers.fontColour;
  const modifierPriceColour = template.productScreen.modifiers.priceColour;

  return (
    <div>
      <div
        className={styles.productOptionsHeader}
        style={{
          backgroundColor: headerBackgroundColor,
          color: headerFontColor,
          fontSize: headerFontSize,
        }}
      >
        <div className={styles.productOptionsHeaderName}>
          Product selections
        </div>
      </div>
      <div
        className={styles.productChildren}
        style={{ fontSize: modifierFontSize, color: modifierFontColor }}
      >
        {prodOptions.map((product, index) => (
          <div
            key={index}
            className={clsx(
              styles.productOption,
              product.soldOut && styles.unavailable
            )}
            onClick={() => !product.soldOut && onProductSelect(product)}
          >
            <div className={styles.productOptionDetails}>
              <div className={styles.productOptionName}>
                {product.name}
                {product.soldOut && " (Sold Out)"}
              </div>
              <div
                className={styles.price}
                style={{ color: modifierPriceColour }}
              >
                {formatAmount(product.price)}
              </div>
            </div>
            <div className={styles.checkboxWrapper}>
              <Checkbox checked={product.code === selectedProductCode} />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AlternateProductSelection;
